import { FormControl } from '@chakra-ui/react';
import { Button, Text, Input } from '@mercator-gcp/grout';
import BasicModal from 'components/elements/BasicModal';
import RadioButtons from 'components/elements/RadioButtons';
import { Spinner } from 'components/elements/Spinner';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { State, STATE_CODE_TO_LABEL } from 'utils/constants/location';

const emptyStateStyle = {
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 'padding_16',
  paddingBottom: 'padding_16',
};
const formBodyStyle = {
  width: '100%',
  maxHeight: '400px',
  overflowY: 'auto',
  minWidth: '300px',
};

type CreateGroupViewProps = {
  groupName: string;
  onGroupNameChange: (value: string) => void;
  selectedState: State;
  onStateChange: (state: State) => void;
  stateOptions: State[];
  regionIdsForSelectedState: string[];
  isLoading: boolean;
  onBack: () => void;
  onSaveAndContinue: () => void;
};

const CreateGroupView = ({
  groupName,
  onGroupNameChange,
  selectedState,
  onStateChange,
  stateOptions,
  regionIdsForSelectedState,
  isLoading,
  onBack,
  onSaveAndContinue,
}: CreateGroupViewProps) => {
  if (isLoading) {
    return (
      <FlexColumn sx={{ ...formBodyStyle, gap: 'padding_16' }}>
        <FlexColumn sx={{ ...emptyStateStyle, minHeight: '120px' }}>
          <Spinner />
          <Text sx={{ marginTop: 'padding_16' }}>Creating group…</Text>
        </FlexColumn>
      </FlexColumn>
    );
  }

  return (
    <>
      <BasicModal.Body title="New Group">
        <FlexColumn sx={{ ...formBodyStyle, gap: 'padding_16' }}>
          <FormControl>
            <Text.SmallLabel sx={{ display: 'block', marginBottom: 'padding_8' }}>
              Group name
            </Text.SmallLabel>
            <Input
              placeholder="e.g. My company group"
              value={groupName}
              onChange={(e) => onGroupNameChange(e.target.value)}
              sx={{ maxWidth: '100%' }}
              autoFocus
            />
          </FormControl>
          <FormControl>
            <Text.SmallLabel sx={{ display: 'block', marginBottom: 'padding_8' }}>
              State
            </Text.SmallLabel>
            <RadioButtons
              value={selectedState}
              onChange={(val) => onStateChange(val as State)}
              options={stateOptions.map((state) => ({
                value: state,
                label: STATE_CODE_TO_LABEL[state] ?? state,
              }))}
            />
          </FormControl>
        </FlexColumn>
      </BasicModal.Body>
      <BasicModal.Footer>
        <Button variant="functional" onClick={onBack}>
          Back
        </Button>
        <Button
          variant="primary"
          onClick={onSaveAndContinue}
          isDisabled={
            !groupName.trim() || regionIdsForSelectedState.length === 0 || isLoading
          }
          isLoading={isLoading}
        >
          Save & Continue
        </Button>
      </BasicModal.Footer>
    </>
  );
};

export default CreateGroupView;
